import { MenuTypes } from '../../modules/flow/services/flowBuilder/utils/flow-step-types.enum';
import assign from 'lodash/assign';

const netWorkOptions = {
  'South Africa': [
    { vendor: 'Vodacom', id: 1 },
    { vendor: 'MTN', id: 2 },
    { vendor: 'Cell C', id: 3 },
    { vendor: 'Telkom Mobile (8ta)', id: 4 },
  ],
  Nigeria: [
    { vendor: '9mobile', id: 1 },
    { vendor: 'Glo', id: 2 },
    { vendor: 'Airtel', id: 3 },
    { vendor: 'MTN NG', id: 4 },
  ],
};

export const DEFAULT = 0;
export const SMS = 6;
export const USSD = 7;
export const WHATSAPP = 8;
export const WEBCHAT = 11;
export const TELEGRAME = 9;
export const FACEBOOK = 10;

export const regexLibrary = [
  {
    name: 'Local & International MSISDN',
    pattern: '(^(0)\\d{10}$)|(^(234)\\d{10}$)',
  },
  {
    name: '4 Digits',
    pattern: '^\\d{4}$',
  },
  {
    name: 'Date (2000-12-31)',
    pattern:
      '^((19\\d{2})|' +
      '(20\\d{2}))-(((02)-(0[1-9]|[1-2][0-9]))|' +
      '(((0(1|[3-9]))|' +
      '(1[0-2]))-(0[1-9]|[1-2][0-9]|30))|' +
      '((01|03|05|07|08|10|12)-(31)))$',
  },
  {
    name: 'Text only',
    pattern: '[a-zA-Z]+',
  },
];

export const CHANNEL_ICONS = {
  [USSD]: {
    icon: 'smartphone',
    type: 'material-icon',
  },
  [WHATSAPP]: {
    icon: 'fa fa-whatsapp',
    type: 'icon',
  },
  [TELEGRAME]: {
    icon: 'fa fa-telegram',
    type: 'icon',
  },
  [FACEBOOK]: {
    icon: 'fa fa-facebook-square',
    type: 'icon',
  },
  [DEFAULT]: {
    icon: 'fa fa-question-circle',
    type: 'icon',
  },
};

const EMULATOR_INPUTS_TYPES = {
  MSISDN: {
    lable: 'Mobile Number',
    formControlName: 'sourceId',
    type: 'input',
    placeholder: 'Enter a test mobile number',
    optional: false,
    tooltip: false,
    additional: false
  },
  INTEGRATION_ID: {
    lable: 'Select Route',
    formControlName: 'route',
    type: 'datalist',
    placeholder: 'Select Route',
    optional: false,
    tooltip: true,
    additional: false
  },
  MOBILE_NETWORK: {
    lable: 'Mobile Network',
    formControlName: 'network',
    type: 'optgroup',
    group: netWorkOptions,
    placeholder: 'Select a mobile network',
    optional: false,
    tooltip: false,
    additional: false
  },
  USSD_CODE: {
    lable: 'USSD Code',
    formControlName: 'route',
    type: 'datalist',
    placeholder: 'Enter a USSD code',
    optional: false,
    tooltip: false,
    additional: false
  },
  MNO_SESSION_ID: {
    lable: 'MNO Session ID',
    formControlName: 'mnoSessionId',
    type: 'input',
    placeholder: 'Enter an MNO Session ID',
    optional: true,
    tooltip: true,
    additional: true
  },
  IMSI: {
    lable: 'IMSI',
    formControlName: 'imsi',
    type: 'input',
    placeholder: 'Enter IMSI number',
    optional: true,
    tooltip: true,
    additional: true
  }
};

export const EMULATOR_INPUTS = {
  [USSD]: [
    EMULATOR_INPUTS_TYPES.MSISDN,
    EMULATOR_INPUTS_TYPES.MOBILE_NETWORK,
    EMULATOR_INPUTS_TYPES.USSD_CODE,
    EMULATOR_INPUTS_TYPES.MNO_SESSION_ID,
    EMULATOR_INPUTS_TYPES.IMSI
  ],
  [WHATSAPP]: [
    EMULATOR_INPUTS_TYPES.MSISDN,
    EMULATOR_INPUTS_TYPES.INTEGRATION_ID
  ],
  [SMS]: [
    EMULATOR_INPUTS_TYPES.MSISDN,
    EMULATOR_INPUTS_TYPES.INTEGRATION_ID
  ],
  [WEBCHAT]: [
    EMULATOR_INPUTS_TYPES.MSISDN,
    EMULATOR_INPUTS_TYPES.INTEGRATION_ID
  ],
};

export const SETTINGS_FIELDS = {
  'channel-id': {
    label: 'Channel ID',
    type: 'text',
    disabled: true,
  },
  'channel-name': {
    label: 'Channel Name',
    type: 'text',
    disabled: true,
  },
  'session-length': {
    label: 'Session Length',
    type: 'text',
    disabled: false,
  },
  'require-opt-in': {
    label: 'Require Opt-In',
    type: 'checkbox-single',
    disabled: false,
  },
  'can-resume': {
    label: 'Can Resume',
    type: 'checkbox-single',
    disabled: false,
  },
  'resume-grace-period': {
    label: 'Resume Grace Period',
    type: 'text',
    disabled: false,
  },
  'resume-message': {
    label: 'Resume Message',
    type: 'text',
    disabled: false,
  },
  'property-layout': {
    label: 'Property Layout',
    type: 'text',
    disabled: false,
  },
};

export const nodeInputTypes: {} = {
  buttonSelect: {
    title: 'Button Selection'
  },
  listOption: {
    title: 'List Options'
  },
  inputMedia: {
    title: 'Incoming Media'
  },
  inputVoiceNote: {
    title: 'Incoming Voice Note'
  },
  inputLocation: {
    title: 'Incoming Location'
  },
  inputText: {
    title: 'Incoming Text'
  },
  inputPayment: {
    title: 'Incoming Payment'
  },
  inputExternalLink: {
    title: 'Incoming External Link'
  },
  inputAuth: {
    title: 'Incoming OAuth'
  },
  start: {
    title: 'Start'
  },
  keyword: {
    title: 'Keyword Input'
  }
};
